import * as React from "react";

interface Props extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

const MailIcon = ({ size = 16, ...props }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.6 0H2.4C1.76348 0 1.15303 0.256807 0.702944 0.713927C0.252856 1.17105 0 1.79103 0 2.4375V10.5625C0 11.209 0.252856 11.829 0.702944 12.2861C1.15303 12.7432 1.76348 13 2.4 13H13.6C14.2365 13 14.847 12.7432 15.2971 12.2861C15.7471 11.829 16 11.209 16 10.5625V2.4375C16 1.79103 15.7471 1.17105 15.2971 0.713927C14.847 0.256807 14.2365 0 13.6 0ZM13.064 1.625L8 5.48438L2.936 1.625H13.064ZM13.6 11.375H2.4C2.18783 11.375 1.98434 11.2894 1.83431 11.137C1.68429 10.9847 1.6 10.778 1.6 10.5625V2.64062L7.52 7.15C7.65848 7.25548 7.8269 7.3125 8 7.3125C8.1731 7.3125 8.34152 7.25548 8.48 7.15L14.4 2.64062V10.5625C14.4 10.778 14.3157 10.9847 14.1657 11.137C14.0157 11.2894 13.8122 11.375 13.6 11.375Z"
      fill={props.color || "currentColor"}
    />
  </svg>
);
export default MailIcon;
